// app/javascript/controllers/autocomplete_teams_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "id"]

  connect() {
    this.index = -1
    this.items = []
    this.timeout = null
    this.abortController = null

    this.boundKeydown = this.keydown.bind(this)
    this.boundOutsideClick = this.outsideClick.bind(this)

    this.inputTarget.addEventListener("keydown", this.boundKeydown)
    document.addEventListener("click", this.boundOutsideClick)
  }

  disconnect() {
    this.inputTarget.removeEventListener("keydown", this.boundKeydown)
    document.removeEventListener("click", this.boundOutsideClick)

    if (this.abortController) {
      this.abortController.abort()
    }

    clearTimeout(this.timeout)
  }

  // chiamato dal data-action input
  search() {
    // invalida l'id precedente se l'utente modifica il testo
    this.idTarget.value = ""
    
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 300)
  }

  performSearch() {
    const query = this.inputTarget.value.trim()

    this.clear()

    if (query.length < 2) return

    // annulla fetch precedente
    if (this.abortController) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()

    fetch(`/teams/autocomplete?query=${encodeURIComponent(query)}`, {
      signal: this.abortController.signal
    })
      .then(response => response.json())
      .then(data => {
        this.clear()

        data.forEach((team, i) => {
          const li = document.createElement("li")
          li.classList.add(
            "list-group-item",
            "list-group-item-action",
            "py-2"
          )

          li.innerHTML = `
            <strong>${team.team}</strong><br>
            <small class="text-muted">
              Provincia: ${team.provincia} - Codice società: ${team.codice_societa}
            </small>  
          `

          li.dataset.id = team.id
          li.dataset.team = team.team

          li.addEventListener("click", () => this.select(i))

          this.resultsTarget.appendChild(li)
          this.items.push(li)
        })
        
        // ✅ MOSTRA dropdown solo se ci sono risultati
        if (this.items.length > 0) {
          this.resultsTarget.classList.remove("d-none")
        }
      })
      .catch(error => {
        if (error.name !== "AbortError") {
          console.error("Autocomplete error:", error)
        }
      })
  }

  keydown(event) {
    if (!this.items.length) return

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.move(1)
        break

      case "ArrowUp":
        event.preventDefault()
        this.move(-1)
        break

      case "Enter":
        if (this.index >= 0) {
          event.preventDefault()
          this.select(this.index)
        }
        break

      case "Escape":
        this.clear()
        break
    }
  }

  move(step) {
    this.index += step

    if (this.index < 0) this.index = this.items.length - 1
    if (this.index >= this.items.length) this.index = 0

    this.items.forEach(el => {
      el.classList.remove("autocomplete-active", "active")
    })

    const active = this.items[this.index]
    active.classList.add("autocomplete-active", "active")
    active.scrollIntoView({ block: "nearest" })
  }

  select(index) {
    const item = this.items[index]

    this.inputTarget.value = item.dataset.team
    this.idTarget.value = item.dataset.id

    this.clear()
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.clear()
    }
  }

  clear() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("d-none")  
    this.items = []
    this.index = -1
  }
}